// extracted by mini-css-extract-plugin
export var section = "ProjectSection-module--section--FWRsF";
export var container = "ProjectSection-module--container--0-wKS";